interface IconComponentProps {
  size?: number | string
}

export const NodeIcon = ({size = 16}: IconComponentProps = {}) => (
  <svg
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 16 16"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    style={{display: 'inline-block', verticalAlign: 'text-bottom'}}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M.5 6v4.5A2.5 2.5 0 0 0 3 13h1.645a3.5 3.5 0 0 1-.11-1.5H3a1 1 0 0 1-1-1V6zM14 6v4.5a1 1 0 0 1-1 1h-1.535a3.5 3.5 0 0 1-.11 1.5H13a2.5 2.5 0 0 0 2.5-2.5V6zm-4 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.5 10V5.5A2.5 2.5 0 0 0 13 3h-1.645a3.5 3.5 0 0 1 .11 1.5H13a1 1 0 0 1 1 1V10zM2 10V5.5a1 1 0 0 1 1-1h1.535a3.5 3.5 0 0 1 .11-1.5H3A2.5 2.5 0 0 0 .5 5.5V10zm4-6a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
      clipRule="evenodd"
    />
  </svg>
)

export const ComposeIcon = ({size = 16}: IconComponentProps = {}) => (
  <svg
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 16 16"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    style={{display: 'inline-block', verticalAlign: 'text-bottom'}}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.515.456a1.555 1.555 0 00-2.2 0L6.58 6.19a1.556 1.556 0 00-.396.673l-.825 2.89a.667.667 0 00.824.824l2.89-.826c.254-.072.485-.209.672-.396l5.735-5.734a1.556 1.556 0 000-2.2l-.965-.965zm-1.257.942a.222.222 0 01.314 0l.965.966a.222.222 0 010 .314L13.415 3.8l-1.28-1.28 1.123-1.122zm-2.065 2.066l1.279 1.279-3.67 3.67a.221.221 0 01-.096.056l-1.736.496.496-1.736c.01-.036.03-.07.057-.096l3.67-3.67zM1.639 4.778a2.25 2.25 0 012.25-2.25h3.154a.75.75 0 000-1.5H3.889a3.75 3.75 0 00-3.75 3.75v7.333a3.75 3.75 0 003.75 3.75h7.333a3.75 3.75 0 003.75-3.75V8.445a.75.75 0 00-1.5 0v3.666a2.25 2.25 0 01-2.25 2.25H3.889a2.25 2.25 0 01-2.25-2.25V4.778z"
      clipRule="evenodd"
    />
  </svg>
)

export const DiceIcon = ({size = 16}: IconComponentProps = {}) => (
  <svg
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 16 16"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    style={{display: 'inline-block', verticalAlign: 'text-bottom'}}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 .5H3A2.5 2.5 0 0 0 .5 3v10A2.5 2.5 0 0 0 3 15.5h10a2.5 2.5 0 0 0 2.5-2.5V3A2.5 2.5 0 0 0 13 .5M2 3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm6 6.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M12.25 5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M5 12.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
      clipRule="evenodd"
    />
  </svg>
)

export const SpacesIcon = ({size = 16}: IconComponentProps = {}) => (
  <svg
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 16 16"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    style={{display: 'inline-block', verticalAlign: 'text-bottom'}}
  >
    <path
      d="M7.41299 14.25H1.75C1.19772 14.25 0.75 13.8023 0.75 13.25V2.75C0.75 2.19772 1.19772 1.75 1.75 1.75H5C5.31476 1.75 5.61115 1.89819 5.8 2.15L6.7 3.35C6.88885 3.60181 7.18524 3.75 7.5 3.75H14.25C14.8023 3.75 15.25 4.19772 15.25 4.75V8.48779"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M12.265 9.15977C12.3446 8.94235 12.6521 8.94235 12.7317 9.15977L12.9693 9.80865C13.3464 10.8387 14.158 11.6503 15.1881 12.0274L15.8369 12.265C16.0544 12.3446 16.0544 12.6521 15.8369 12.7317L15.1881 12.9692C14.158 13.3463 13.3464 14.158 12.9693 15.188L12.7317 15.8369C12.6521 16.0543 12.3446 16.0543 12.265 15.8369L12.0275 15.188C11.6504 14.158 10.8387 13.3463 9.80871 12.9692L9.15983 12.7317C8.94241 12.6521 8.94241 12.3446 9.15983 12.265L9.80871 12.0274C10.8387 11.6503 11.6504 10.8387 12.0275 9.80865L12.265 9.15977Z"
      fill="currentColor"
    />
  </svg>
)

export const LoopsIcon = ({size = 16}: IconComponentProps = {}) => (
  <svg
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 16 16"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    style={{display: 'inline-block', verticalAlign: 'text-bottom'}}
  >
    <path
      d="M16.0376 9.67565V5.82038C16.0376 5.69043 15.9257 5.58508 15.7876 5.58508H11.6914C11.4687 5.58508 11.3571 5.83853 11.5146 5.98676L15.6108 9.84196C15.7683 9.99019 16.0376 9.88525 16.0376 9.67565Z"
      fill="currentColor"
    />
    <path
      d="M1.89601 3.25629C4.26064 1.03075 8.04807 0.960969 10.5015 3.04765L10.7339 3.25629L10.7857 3.3096C11.0259 3.58685 11.0085 3.99602 10.7339 4.25445C10.4593 4.51252 10.0254 4.52825 9.73097 4.30225L9.67336 4.25445L9.4966 4.09544C7.63201 2.50983 4.75358 2.56313 2.95656 4.25445C1.10158 6.00031 1.10158 8.83023 2.95656 10.5761C4.81155 12.322 7.8184 12.3219 9.67336 10.5761L13.563 6.91622C13.8559 6.64063 14.3307 6.64058 14.6236 6.91622C14.9163 7.19186 14.9163 7.63873 14.6236 7.91438L10.7339 11.5752C8.29328 13.8718 4.33667 13.8718 1.89601 11.5752C-0.544758 9.27799 -0.544771 5.55349 1.89601 3.25629Z"
      fill="currentColor"
    />
  </svg>
)

export const iconMapping = {
  compose: ComposeIcon,
  dice: DiceIcon,
  loops: LoopsIcon,
  node: NodeIcon,
  spaces: SpacesIcon,
}

export type IconName = keyof typeof iconMapping

try{ NodeIcon.displayName ||= 'NodeIcon' } catch {}
try{ ComposeIcon.displayName ||= 'ComposeIcon' } catch {}
try{ DiceIcon.displayName ||= 'DiceIcon' } catch {}
try{ SpacesIcon.displayName ||= 'SpacesIcon' } catch {}
try{ LoopsIcon.displayName ||= 'LoopsIcon' } catch {}